module.exports = __webpack_public_path__ + "img/back2.6c9efe0c.svg";